import React, { FunctionComponent } from 'react';
import styles from './link-box.module.scss';
import { InternalLink } from '../internal-link/internal-link';
import classNames from 'classnames/bind';

export interface ILinkBoxProps {
  image: {
    url: string;
    description: string;
  };
  title: string;
  url: string;
  backgroundColor: string;
  textPosition: string;
  description: string;
}

const cx = classNames.bind(styles);

export const LinkBox: FunctionComponent<ILinkBoxProps> = ({
  image,
  title,
  url,
  backgroundColor,
  textPosition,
  description
}) => {
  const wrapperClass = cx({
    backgroundColorPrimary: backgroundColor === 'primary',
    backgroundColorWhite: backgroundColor === 'white',
    backgroundColorSecondary: backgroundColor === 'secondary',
    backgroundColorLightGray: backgroundColor === 'light_gray',
    backgroundColorTransparent: backgroundColor === 'transparent',
    positionLeft: textPosition === 'left',
    positionCenter: textPosition === 'center',
    positionRight: textPosition === 'right',
    paddingBottom: description.length > 0
  });

  const content = (
    <div className={styles.wrapper}>
      <div className={styles.imageWrapper}>
        {image && (
          <img
            className={styles.image}
            src={image.url}
            alt={image.description}
          />
        )}
      </div>
      <div className={`${styles.overlay} ${wrapperClass}`}>
        <div
          className={styles.textWrapper}
          style={{ textAlign: textPosition || 'center' }}
        >
          <span className={styles.text}>{title}</span>
          <div className={styles.description}>{description}</div>
        </div>
      </div>
    </div>
  );

  return (
    <React.Fragment>
      {url ? <InternalLink url={url}>{content}</InternalLink> : content}
    </React.Fragment>
  );
};
